import React from 'react';
import './WhatsAppButton.css';
import { useSiteInfo } from '../../context/SiteInfoContext';

const WhatsAppButton = () => {
  const { siteInfo } = useSiteInfo();
  const whatsapp = siteInfo?.whatsapp;

  if (!whatsapp) {
    return null;
  }

  const href = `https://wa.me/${whatsapp.number}?text=${encodeURIComponent(whatsapp.defaultMessage)}`;

  return (
    <a
      className="whatsapp-float"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with JAC Cars on WhatsApp"
      title="Chat with us on WhatsApp"
    >
      <span className="whatsapp-pulse" aria-hidden="true" />
      <svg
        className="whatsapp-icon"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        focusable="false"
      >
        <path
          fill="currentColor"
          d="M16.001 3.2c-7.07 0-12.8 5.73-12.8 12.8 0 2.26.6 4.46 1.74 6.39L3.2 28.8l6.6-1.71a12.74 12.74 0 0 0 6.2 1.58h.01c7.07 0 12.8-5.73 12.8-12.8s-5.74-12.67-12.81-12.67Zm0 23.31h-.01a10.56 10.56 0 0 1-5.39-1.48l-.39-.23-3.92 1.02 1.05-3.81-.25-.4a10.5 10.5 0 0 1-1.61-5.61c0-5.81 4.73-10.54 10.54-10.54 2.82 0 5.46 1.1 7.45 3.09a10.46 10.46 0 0 1 3.08 7.45c0 5.81-4.73 10.51-10.55 10.51Zm5.78-7.88c-.32-.16-1.88-.93-2.17-1.03-.29-.11-.5-.16-.71.16-.21.32-.81 1.03-.99 1.24-.18.21-.36.24-.68.08-.32-.16-1.34-.49-2.55-1.57a9.55 9.55 0 0 1-1.77-2.2c-.18-.32-.02-.49.14-.65.14-.14.32-.36.48-.54.16-.18.21-.32.32-.53.11-.21.05-.4-.03-.56-.08-.16-.71-1.71-.98-2.34-.26-.62-.52-.53-.71-.54l-.61-.01a1.17 1.17 0 0 0-.85.4c-.29.32-1.12 1.1-1.12 2.69 0 1.59 1.15 3.12 1.31 3.34.16.21 2.27 3.47 5.5 4.86.77.33 1.37.53 1.84.68.77.24 1.47.21 2.02.13.62-.09 1.88-.77 2.15-1.51.27-.74.27-1.38.19-1.51-.08-.13-.29-.21-.61-.37Z"
        />
      </svg>
      <span className="whatsapp-label">Chat on WhatsApp</span>
    </a>
  );
};

export default WhatsAppButton;
